import React from 'react'
import CanvasDraw from "react-canvas-draw";

const Draw = () => {
    return (
        <div>
            <div className="level-item">
                <p className="is-size-2">Doodle</p>
            </div>
            <div className="level-item">
                <p className="is-size-3">Use this section to illustrate any problems you have</p>
            </div>
            <div className="level-item">
                <CanvasDraw />
            </div>
        </div>
    )
}

export default Draw